import { Box, Stack, Typography } from "@mui/material"
import { round2 } from "../format-utils"
import { CostFigure } from "./cost-figure"

export function VariantBreakdownFacilityRow({ item, currency }) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            sx={{ px: 2, py: 1, borderBottom: 1, borderColor: "divider", "&:last-child": { borderBottom: 0 } }}
        >
            <Box sx={{ flex: 2 }}>
                <Typography variant="body2">{item.facilityName}</Typography>
            </Box>
            <Box sx={{ flex: 1, textAlign: "right" }}>
                <Typography variant="body2" color="text.secondary">
                    {round2(item.totalHours)}h
                </Typography>
            </Box>
            <Box sx={{ flex: 1, textAlign: "right" }}>
                <CostFigure value={item.totalCost} currencySymbol={currency} fontWeight={500} />
            </Box>
            <Box sx={{ width: 50, textAlign: "right" }}>
                <Typography variant="caption" color="text.secondary">
                    {round2(item.percentage)}%
                </Typography>
            </Box>
        </Stack>
    )
}
